import React from "react"
import CheckAccount from "../../../images/check-account.png"
import DownloadMobileApp from "../../../images/download-mobile-app.png"
import ShippingAddress from "../../../images/shipping-address.png"
import FuelAndSave from "../../../images/fuel-and-save.png"
import SwipeFuelCard from "../../../images/swipe-fuel-card.png"
import FindFuelStation from "../../../images/find-fuel-station.png"
import { useTranslation } from "react-i18next"
import FeatureList from "./FeatureList"
import { withRouter } from "react-router-dom"

const FuelFeatures = ({ handleFuelCardFlag }) => {
  const { t } = useTranslation("fuelcardRequest")

  const FEATURE_LIST_1 = [
    {
      image: ShippingAddress,
      label: t("provideShippingAddress")
    },
    {
      image: CheckAccount,
      label: t("secureAccount")
    },
    {
      image: DownloadMobileApp,
      label: t("downloadMobileApp")
    }
  ]

  const FEATURE_LIST_2 = [
    {
      image: FindFuelStation,
      label: t("findFuelStation")
    },
    {
      image: SwipeFuelCard,
      label: t("swipeFuelCard")
    },
    {
      image: FuelAndSave,
      label: t("fuelAndSave")
    }
  ]

  const handleRequestCardDialog = () => {
    handleFuelCardFlag(true)
  }

  return (
    <div className="fuel-features-container">
      <FeatureList
        sectionHeader={t("signupAndSaving")}
        featureList={FEATURE_LIST_1}
        buttonClick={handleRequestCardDialog}
      />
      <FeatureList
        sectionHeader={t("savebigOnGallon")}
        hideFuelButtonInMobile
        alignInOneRow
        featureList={FEATURE_LIST_2}
        buttonClick={handleRequestCardDialog}
      />
    </div>
  )
}

export default withRouter(FuelFeatures)
